import { render, staticRenderFns } from "./InactivityWarningModal.vue?vue&type=template&id=b0647754&scoped=true&lang=pug"
import script from "./InactivityWarningModal.vue?vue&type=script&lang=js"
export * from "./InactivityWarningModal.vue?vue&type=script&lang=js"
import style0 from "./InactivityWarningModal.vue?vue&type=style&index=0&id=b0647754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0647754",
  null
  
)

export default component.exports